import { cn } from 'lib/helpers/utility';

import Divider from 'components/shared/Divider/Divider';
import Typography from 'components/shared/Typography/Typography';

import {
  patchAssuranceAction,
  setLetterTypeAction,
  setPhasesAction
} from '../../lib/paymentSetupReducer';

import AssuranceRating from './components/AssuranceRating';
import PaymentTypes from './components/PaymentTypes/PaymentTypes';
import PerPhaseConfiguration from './components/PerPhaseConfiguration/PerPhaseConfiguration';
import SendToPatients from './components/SendToPatients';

const PaymentSettings = ({ draft, dispatch, activePhaseField, setActivePhaseField, className }) => {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 flex-col items-center gap-6 overflow-y-auto px-4 py-5',
        className
      )}>
      <div className="flex flex-col gap-2">
        <Typography variant="h6">Payment program setup</Typography>
        <Typography variant="p" size="small" color="neutral-700">
          Configure payment methods, card-on-file policies, charge limits, and authorization terms.
          Settings here drive both your Patient Option Letter and the Pre-Authorized Healthcare
          form.
        </Typography>
      </div>
      <SendToPatients
        value={draft.letter_type}
        onChange={(value) => dispatch(setLetterTypeAction(value))}
      />
      <Divider />
      <AssuranceRating
        value={draft.assurance_thresholds}
        onChange={(patch) => dispatch(patchAssuranceAction(patch))}
      />
      <Divider />
      <PaymentTypes methods={draft.payment_methods} dispatch={dispatch} />
      <Divider />
      <PerPhaseConfiguration
        phases={draft.phases}
        onChange={(nextPhases) => dispatch(setPhasesAction(nextPhases))}
        activePhaseField={activePhaseField}
        setActivePhaseField={setActivePhaseField}
      />
    </div>
  );
};

export default PaymentSettings;
